import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

/* Game data are in the variable gamesData in this provider */

@Injectable()
export class GameModel {
    gamesData: any=[];
    userCurrenteState

    constructor(private storage: Storage){
		this.getInitialGamesDataFromStorage();
    }

    addWord(
        idBook:number,
        idGame: number,
        round:number,
        attempt:number,
        bookmark:number,
        timeLeft:number,
        skipLeft:number,
        tsInsert:number,
        skipUsed:boolean,
        word:string,
        wordToGuess: string,
        isCorrect:boolean){
        this.gamesData[idGame].wordstyped.push({
            idBook: idBook,
            round: round,
            attempt: attempt,
            bookmark: bookmark,
            timeLeft: timeLeft,
            skipLeft: skipLeft,
            tsInsert: tsInsert,
            skipUsed: skipUsed,
            word: word,
            wordToGuess,
            isCorrect: isCorrect
        });
        this.storeGamesData();
    }

    addGame(
        guidUser: string,
        level: number,
        idGame: number,
        idBook:number,
        currentDevice:any,
        numSntToGuess: number,
        tsBegingame:number,
        tsEndgame:number,
        difficulty:string,
        language:string,
        scoreInitial:number,
        scoreFinal:number,
        skipInitial:number,
        skipFinal:number,
        bookmarkInitial:number,
        bookmarkFinal:number,
        giveup:boolean,
        win:boolean,
        timeLeft:number,
        wordstyped:any){
        this.gamesData.push({
            guidUser:guidUser,
            level: level,
            idGame:idGame,
            idBook: idBook,
            currentDevice: currentDevice,
            numSntToGuess: numSntToGuess,
            tsBegingame: tsBegingame,
            tsEndgame: tsEndgame,
            difficulty: difficulty,
            language: language,
            scoreInitial: scoreInitial,
            scoreFinal: scoreFinal,
            skipInitial: skipInitial,
            skipFinal: skipFinal,
            bookmarkInitial:bookmarkInitial,
            bookmarkFinal:bookmarkFinal,
            giveup:giveup,
            win:win,
            timeLeft: timeLeft,
            wordstyped: wordstyped || []
        });

        this.storeGamesData();
    }

    setWin(idGame,value){
        this.gamesData[idGame].win=value;        
    }
    setGiveUp(idGame,value){
        this.gamesData[idGame].giveup=value;        
    }
    setTsEndgame(idGame,value){
        this.gamesData[idGame].tsEndgame=value;
    }
    setScoreFinal(idGame,value){
        this.gamesData[idGame].scoreFinal=value;
    }
    setSkipFinal(idGame,value){
        this.gamesData[idGame].skipFinal=value;
    }
    setBookmarkFinal(idGame,value){
        this.gamesData[idGame].bookmarkFinal=value;
    }
    setTimeLeft(idGame,value){
        this.gamesData[idGame].timeLeft=value;
    }

    getNewGameId(){
        var idGame;
        if(this.gamesData.length==0){ 
            idGame=0;
        }else{
            idGame=this.gamesData.length;
        }
        return idGame;
    }

    getCurrentGameId(){
        var idGame;
        if(this.gamesData.length==0){ 
            idGame=0;
        }else{
            idGame=this.gamesData.length-1;
        }
        return idGame;
    }
    /*removeItem(gameData){
        var i:number;
        for(i = 0; i < this.gameData.length; i++) {
            if(this.gameData[i] == item){
                this.gameData.splice(i, 1);
            }
        }
    }*/

    clearGamesData(){
        return new Promise((resolve) =>{
            this.gamesData=[];
            this.gamesData.push({});
            this.storeGamesData().then((response)=>{
                resolve("storeGamesDataOk");
            });
        });
    }

    storeGamesData(){
        return new Promise((resolve) =>{
            this.storage.set('gamesData', JSON.stringify(this.gamesData)).then((val) => {
                resolve("storeGamesDataOk");
            })
        });
    }

    getInitialGamesDataFromStorage(){
        this.storage.get('gamesData').then((gamesData) => {
            if(gamesData){
                this.gamesData=JSON.parse(gamesData);
            }else{
                this.gamesData=[];
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/providers/game-model.ts